import { useEffect, useState } from "react";
import { Grid, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, CircularProgress, Autocomplete, Box, Tooltip, Typography, } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { globalPostService, globalPutService } from "../../../../utils/globalApiServices";
import { checkApiStatus } from "../../../../utils";
import { useSnackbar } from "notistack";
import moment from "moment";
import { AttachementsUpload } from "../../../../shared_elements/components";
import { addMuiApi, editMouApi } from "../apiServices";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { backendDateFormat, fieldDateFormat } from "../../../../constants";
import { getLesseeApi, getOwnerLessorApi } from "../../../../shared_elements/actionCreators";
import { trackActivity } from "../../../../utils/mixpanel";
import { formatBytes } from "../../../../utils/fileUpload";
import { setFileUploadDetails } from "../../../../shared_elements/actions";
import { regexConstants } from "../../../../constants/regEx";

const MouCRU = ({ addEditMou, modeType, fileUpload, getResponseBack, onToggleModal, onOpenAttachments }) => {
  const dispatch = useDispatch()
  const params = useParams()
  const { lessee, lessor } = useSelector((state) => state.leases);
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setLoading] = useState(false);
  const [data, setData] = useState(addEditMou?.data);
  const [isDropDownLoading, setIsDropDownLoading] = useState({ lessee: !(lessee?.length > 0), lessor: !(lessor?.length > 0)});
  const [error, setError] = useState({});
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const {storageDetails } = useSelector((state) => state.leases);

  useEffect(() => {
    if (!lessee?.length) {
      dispatch(getLesseeApi({setIsDropDownLoading}));
    }
    if (!lessor?.length) {
      dispatch(getOwnerLessorApi({setIsDropDownLoading}));
    }
  }, [dispatch]);

  const onRestErrorKey = (key) => {
    setError((prev) => ({ ...prev, [key]: '' }));
  };

  const onFieldChange = (key, value) => {
    setData({ ...data, [key]: value });
    setError((prev) => ({ ...prev, [key]: '' }));
  };

   const handleFileChange = (files) => {
          setUploadedFiles(files);
          dispatch(setFileUploadDetails({attachments:files}))
      };

  const onAddEditMou = () => {
    const validationInputs = {
      mou_date: data?.mou_date ? "" : "Please enter Mou Date",
      lessee_id: data?.lessee?.id ? "" : "Please select Lessee",
      lessor_id: data?.lessor?.id ? "" : "Please select Lessor",
      managed: data?.managed ? "" : "Please Enter Managed",
      tied_asset: data?.tied_asset ? "" : "Please Enter Asset"
    };
    if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
      setLoading(true);
      if (data.id) {
        globalPutService(editMouApi({ ...params, slug: data?.slug }),{...data,lessee_id: data?.lessee, lessor_id: data?.lessor}).then(async (response) => {
          if (checkApiStatus(response)) {
            if (uploadedFiles?.length) {
              fileUpload(data?.slug,'updated')
            }
            enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" } });
            onToggleModal()
            getResponseBack();
            setLoading(false);
            trackActivity('Item Edited', { page_title: `Edit Mou`, success_msg: response?.data?.message, item_id: data?.id, payload: data, response: response?.data })
          } else {
            setLoading(false);
            enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
            trackActivity('Item Edited', { page_title: `Edit Mou`, error_msg: response?.data?.message, item_id: data?.id, payload: data, response: response?.data })
          }
        });
      } else {
        const { lessee, lessor, ...cleanedData } = data
        globalPostService(addMuiApi(params), { ...cleanedData, lessee_id: data?.lessee, lessor_id: data?.lessor }).then(async (response) => {
          if (checkApiStatus(response)) {
            if (uploadedFiles?.length) {
              fileUpload(response?.data?.data?.slug,'created')
            }
            enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
            onToggleModal()
            getResponseBack();
            setLoading(false);
            trackActivity('Item Added', { page_title: `Add Mou`, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: data, response: response?.data })
          } else {
            setLoading(false);
            enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
            trackActivity('Item Added', { page_title: `Add Mou`, error_msg: response?.data?.message, item_id: null, payload: data, response: response?.data })
          }
        });
      }
    } else {
      setError(validationInputs);
      trackActivity(`Item ${modeType === 'add' ? 'Added' : 'Edited'}`, { page_title: data?.id ? `${addEditMou.mode === "view" ? "View" : "Edit"} Mou` : "Add Mou", error_msg: validationInputs, })
    }
  };
  const handleItemClicked = (page_type) => {
    trackActivity('Item Clicked', { page_title: data?.id ? `${addEditMou.mode === "view" ? "View" : "Edit" } Mou` : "Add Mou", page_type: page_type, })
  }

  return (
    <>
      <Dialog
        onClose={(event, reason) => {
          if (reason !== 'backdropClick') {
            onToggleModal();
          }
        }}
        disableEscapeKeyDown
        aria-labelledby="customized-dialog-title"
        className="add-lease-dialog"
        maxWidth="md"
        open={addEditMou.modal}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header'>
          <Typography className="dialog-header-title">
            {data?.id ? `${addEditMou.mode === "view" ? "View" : "Edit"} MOU` : "Add MOU"}
          </Typography>
        </DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid size={{ md: 4, xs: 12 }}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  required
                  value={data?.mou_date ? moment(data.mou_date) : null}
                  onChange={(data) => {
                    const isValid = moment(data)?.isValid();
                    const formattedmou_date = data ? moment(data).format(backendDateFormat) : null;
                    onFieldChange("mou_date", formattedmou_date);
                    if (isValid) {
                      onRestErrorKey("mou_date");
                    }
                  }}
                  slotProps={{
                    textField: {
                      label:"MOU Date",
                      required: true,
                      InputLabelProps: { shrink: true },
                      size: "small",
                      margin: "normal",
                      error: error.mou_date || false,
                      helperText: error.mou_date || '',
                    },
                    field: {
                      clearable: true,
                      onClear: () => {
                        onFieldChange("mou_date", null);
                        onRestErrorKey("mou_date");
                      }
                    },
                  }}
                  sx={{ width: "100%" }}
                  format={fieldDateFormat}
                  disabled={modeType === 'view'}
                />
              </LocalizationProvider>
            </Grid>
            <Grid size={{ md: 4, xs: 12 }}>
              <Autocomplete
                disablePortal
                disableClearable
                options={lessee || []}
                noOptionsText={isDropDownLoading?.lessee ? "Loading..." :"No Option Available" }
                disabled={modeType === 'view'}
                getOptionLabel={(option) => option?.name || ""}
                value={lessee?.find((option) => option.id === data?.lessee?.id) || null}
                onChange={(e, value) => { onFieldChange("lessee", value) }}
                onFocus={() => onRestErrorKey("lessee_id")}
                slotProps={{listbox: {style: { maxHeight: 100, overflowY: "auto" }},input: {sx: {boxSizing: "border-box",width:"auto"},},}}
                renderInput={(params) => {
                  const selectedLabel = params?.inputProps?.value || "";
                  return (
                  <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow >
                  <TextField
                    required
                    {...params}
                    label="Lessee"
                    margin='normal'
                    size='small'
                    error={error.lessee_id || false}
                    helperText={error.lessee_id || ''}
                    disabled={modeType === 'view'}
                    slotProps={{
                    inputLabel: {
                    shrink: true,
                     },
                    input:{ ...params?.InputProps,endAdornment: (<>{isDropDownLoading?.lessee ? ( <CircularProgress color="inherit" size={20} />) : null}
                    {params?.InputProps?.endAdornment}
                  </>
                     )
                  }}}
                  />
                </Tooltip>)}}
              />
            </Grid>
            <Grid size={{ md: 4, xs: 12 }}>
              <Autocomplete
                disablePortal
                disableClearable
                options={lessor || []}
                disabled={modeType === 'view'}
                getOptionLabel={(option) => option?.name || ""}
                noOptionsText={isDropDownLoading?.lessor ? "Loading..." :"No Option Available" }
                value={lessor?.find((option) => option.id === data?.lessor?.id) || null}
                slotProps={{listbox: {style: { maxHeight: 100, overflowY: "auto" }},input: {sx: {boxSizing: "border-box",width:"auto"},},}}
                onChange={(e, value) => { onFieldChange("lessor", value) }}
                onFocus={() => onRestErrorKey("lessor_id")}
                renderInput={(params) => {
                  const selectedLabel = params?.inputProps?.value || "";
                  return (
                  <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow >
                  <TextField
                    required
                    {...params}
                    label="Lessor/Holdco"
                    margin='normal'
                    size='small'
                    error={error.lessor_id || false}
                    helperText={error.lessor_id || ''}
                    disabled={modeType === 'view'}
                    slotProps={{
                    inputLabel: {
                    shrink: true,
                     },
                    input:{ ...params?.InputProps,endAdornment: (<>{isDropDownLoading?.lessor ? ( <CircularProgress color="inherit" size={20} />) : null}
                    {params?.InputProps?.endAdornment}
                  </>
                     )
                  }}}/>
                </Tooltip>)}}
              />
            </Grid>
            <Grid size={{ md: 4, xs: 12 }}>
              <TextField
                disabled={addEditMou.mode === "view"}
                required
                id="managed"
                label="Managed"
                variant="outlined"
                size="small"
                margin="normal"
                value={data?.managed || ""}
                onChange={(e) => regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("managed", e.target.value.trimStart()) : e.preventDefault()}
                onFocus={() => onRestErrorKey("managed")}
                error={Boolean(error.managed)}
                helperText={error.managed}
                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 25 } }}
                fullWidth
              />
            </Grid>
            <Grid size={{ md: 4, xs: 12 }}>
              <TextField
                disabled={addEditMou.mode === "view"}
                required
                id="tied_asset"
                label="Linked Asset"
                variant="outlined"
                size="small"
                margin="normal"
                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 25 } }}
                value={data?.tied_asset || ""}
                onChange={(e) => regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("tied_asset", e.target.value.trimStart()) : e.preventDefault()}
                onFocus={() => onRestErrorKey("tied_asset")}
                error={Boolean(error.tied_asset)}
                helperText={error.tied_asset || (data?.tied_asset?.length > 25 ? "Maximum 25 characters allowed" : "")}
                fullWidth
              />

            </Grid>
            <Grid size={{ md: 12, xs: 12 }} sx={{mt: 3}}>
              <Box sx={{display:"flex",justifyContent:"space-between"}} >
              {data?.id && data?.attachments?.length ?
                <Button onClick={() => { onOpenAttachments(); handleItemClicked('ViewAttachments Button') }} size='small' variant='outlined' color='primary' sx={{ marginBottom: '10px' }}>({addEditMou?.data?.attachments?.length})Attachment(s)</Button> : null
              }
               <Button className='available-space-btn' disableRipple size='small' variant='outlined' color='primary'>{`Available Space : ${formatBytes(storageDetails?.remaining_storage)}`}</Button>
              </Box>
              {modeType === 'view' ? null : <AttachementsUpload onFileChange={handleFileChange} attachments={data?.attachments} remainingStorage={storageDetails?.remaining_storage} />}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions className="dialog-action">
          <Button className="cancel-btn" disabled={isLoading} variant="outlined" size="small" onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}>{modeType === "view" ? "Close" : "Cancel"}</Button>
          {modeType === "view" ? null : 
          <Button variant="contained" size="small" className="btn-primary" onClick={() => { handleItemClicked('Save Button'); onAddEditMou() }}> {isLoading ? <CircularProgress color='inherit' size={25} /> : "SAVE"}</Button>}
        </DialogActions>
      </Dialog>
    </>
  );
};
export default MouCRU;